import { createApp } from 'vue'
import { ref } from "vue";
import VueMatomo from 'vue-matomo'
import App from './App.vue'
import router from './router'

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

export default {
  name: 'App',
  data: () => ({
  }),
  methods: {
  }
};
import 'uikit/dist/css/uikit.min.css';
import './assets/css/main.css';
import store from './store'
//console.log(__dirname);
createApp(App).use(store).use(router).use(VueMatomo,{host: '//mgr.sfrhd.net/',siteId: 1,trackerFileName:'matomo',router: router,enableLinkTracking: true,cookieDomain:'*.grandraid.sfr.re',domains:'*.grandraid.sfr.re',trackInitialView: true,debug: false,}).mount('#app')
